import "../Component2/css/Privacypolicies.css";
import SEO from "../SEO";
import { seoConfig } from "../config/seoConfig";
import logo from "../Component2/logo/hirelink.png";

function PrivacyPolicies() {
  return (
    <>
      <SEO
        title={seoConfig.c_privacy.title}
        description={seoConfig.c_privacy.description}
      />
      <div className="cpp-body">
        <div
          className="cpp-wrapper"
          style={{ backgroundImage: `url(${logo})` }}
        >
          <div className="cpp-container">
            <h1 className="cpp-title"style={{fontWeight:"bold"}}>Candidate Privacy Policy</h1>
            <h5 className="cpp-heading">
              Hirelink Infotech Pvt Ltd – HirelinkInfo Pharma Job Portal
            </h5>
            <h3 className="cpp-heading">Website: https://hirelinkinfo.com</h3>

            <h3 className="cpp-heading">1. Introduction</h3>
            <p className="cpp-text">
              Hirelink Infotech Pvt Ltd (“HirelinkInfo”, “we”, “our”, or “us”)
              operates a professional pharma job portal that connects
              pharmaceutical job seekers with employers across India.
            </p>
            <p className="cpp-text">
              This Privacy Policy explains how we collect, use, store, process,
              and protect personal information when candidates:
            </p>
            <p className="cpp-text">
              ● Register on https://hirelinkinfo.com <br></br> ● Use our pharma
              job portal<br></br>● Download and use our Android or iOS mobile
              application<br></br> ● Apply for pharmaceutical job opportunities
            </p>
            <p className="cpp-text">
              By accessing or using HirelinkInfo, you agree to the terms
              outlined in this Privacy Policy.
            </p>

            <h3 className="cpp-heading">2. Who This Policy Applies To</h3>
            <p className="cpp-text">This Privacy Policy applies to:</p>
            <p className="cpp-text">
              ● Pharma job seekers<br></br>● Registered candidates<br></br> ●
              Website visitors<br></br> ● Mobile application users
            </p>

            <p className="cpp-text">
              It does not apply to employer internal hiring processes after you
              share your information with them
            </p>

            <h3 className="cpp-heading">3. Information We Collect</h3>

            <p className="cpp-text">
              When you use our job portal, we may collect the following
              categories of information:
              <h6 className="cpp-headin" style={{ fontWeight: "bold" }}>
                A. Personal Information
              </h6>
              <p className="cpp-text">
                ● Full name <br></br>● Mobile number<br></br> ● Email address
                <br></br> ● City and state<br></br> ● Educational qualifications
                <br></br> ● Work experience (QA, QC, Production, R&D, Sales,
                etc.)<br></br> ● Resume/CV<br></br> ● Skills and certifications
              </p>
              <h6 className="cpp-headin" style={{ fontWeight: "bold" }}>
                B. Account Information
              </h6>
              <p className="cpp-text">
                ● Username<br></br>● Password (encrypted)<br></br>● Candidate
                score<br></br>● Interview activity
              </p>
              <h6 className="cpp-headin" style={{ fontWeight: "bold" }}>
                C. Device & Technical Information
              </h6>
              <p className="cpp-text">
                ● IP address<br></br>● Device type<br></br>● Operating system
                <br></br>● App version<br></br>● Browser type<br></br>● Log data
              </p>
              <h6 className="cpp-headin" style={{ fontWeight: "bold" }}>
                D. Communication Data
              </h6>
              <p className="cpp-text">
                ● Messages sent through the platform<br></br>● Interview
                confirmations<br></br>● Support queries<br></br>
              </p>
              <p className="cpp-text">
                We collect only information that is necessary to operate a
                professional and secure pharma job portal.
              </p>
            </p>

            <h3 className="cpp-heading">4. How We Use Your Information</h3>

            <p className="cpp-text">Your information is used for:</p>
            <p className="cpp-text">
              ● Creating and managing your candidate profile<br></br>●
              Displaying your profile to relevant pharmaceutical employers
              <br></br>● Matching you with pharma job openings<br></br>● Sending
              interview notifications and updates<br></br>● Improving job
              recommendations<br></br>● Maintaining platform security<br></br>●
              Preventing fraud or misuse<br></br>● Complying with legal
              obligations
            </p>
            <p className="cpp-text">
              We do NOT sell your personal information to third parties.
            </p>

            <h3 className="cpp-heading">5. Profile Visibility</h3>

            <p className="cpp-text">
              ● Your resume and professional details may be visible to
              registered employers and recruiters.<br></br>● You understand that
              job portals operate as public career platforms.<br></br>● We are
              not responsible for how employers use the information you
              voluntarily share<br></br>
              with them.
            </p>
            <p className="cpp-text">
              Candidates should avoid uploading sensitive personal documents
              unless required for job application purposes
            </p>

            <h3 className="cpp-heading">
              6. Mobile App Permissions (Android & iOS Compliance)
            </h3>

            <p className="cpp-text">
              Our mobile application may request limited permissions such as:
            </p>
            <p className="cpp-text">
              ● Internet access (for job updates)<br></br>● Storage access (for
              resume upload)<br></br>● SMS verification (for OTP authentication)
              <br></br>
            </p>
            <p className="cpp-text">We do not access:</p>
            <p className="cpp-text">
              ● Contacts<br></br>● Photos (unless you upload voluntarily)
              <br></br>● Microphone<br></br>● Camera (unless required for
              optional verification){" "}
            </p>
            <p className="cpp-text">
              Permissions are used strictly to enhance job portal functionality
              and security.
            </p>

            <h3 className="cpp-heading">7. Data Sharing Policy</h3>

            <p className="cpp-text">We may share your information only with:</p>
            <p className="cpp-text">
              ● Verified pharmaceutical employers<br></br>● Authorized
              recruitment partners<br></br>● Technical service providers
              (hosting, analytics, security)<br></br>● Government authorities
              when legally required
            </p>
            <p className="cpp-text">
              We do not share personal data for advertising resale.{" "}
            </p>

            <h3 className="cpp-heading">8. Data Security Measures</h3>

            <p className="cpp-text">
              HirelinkInfo uses reasonable administrative and technical
              safeguards, including:
            </p>
            <p className="cpp-text">
              ● Encrypted passwords<br></br>● Secure servers<br></br>● Firewall
              protection<br></br>● Limited access controls
            </p>

            <p className="cpp-text">
              However, no online job portal can guarantee 100% security. Users
              are responsible for safeguarding their login credentials
            </p>

            <h3 className="cpp-heading">
              9. Candidate Score & Activity Tracking
            </h3>

            <p className="cpp-text">
              For maintaining employer trust within our pharma job portal:
            </p>
            <p className="cpp-text">
              ● Interview attendance is recorded<br></br>● Candidate score
              adjustments may apply{" "}
            </p>
            <p className="cpp-text">
              This tracking is used only for internal ranking and platform
              transparency.
            </p>

            <h3 className="cpp-heading">Candidate Account Responsibility</h3>

            <p className="cpp-text">
              Candidates are responsible for maintaining the confidentiality of
              their login credentials. Any activity performed through the
              candidate account will be the responsibility of the candidate.
            </p>

            <h3 className="cpp-heading">10. Data Retention</h3>

            <p className="cpp-text">We retain candidate information:</p>
            <p className="cpp-text">
              ● As long as your account remains active<br></br>● As required by
              legal or compliance obligations{" "}
            </p>
            <p className="cpp-text">
              You may request account deactivation by contacting support.
            </p>

            <h3 className="cpp-heading">11. Cookies & Tracking Technologies</h3>

            <p className="cpp-text">
              HirelinkInfo may use cookies and similar technologies to:
            </p>
            <p className="cpp-text">
              ● Improve website performance<br></br>● Analyze traffic<br></br>●
              Enhance job search experience{" "}
            </p>
            <p className="cpp-text">
              You may disable cookies in your browser settings, but some
              features may not function properly.
            </p>

            <h3 className="cpp-heading">12. Third-Party Links</h3>

            <p className="cpp-text">
              Our job portal may contain links to external websites. We are not
              responsible for the privacy practices of those third-party
              platforms.
            </p>
            <p className="cpp-text">
              Candidates should review third-party privacy policies before
              sharing personal information.
            </p>

            <h3 className="cpp-heading">13. Children’s Privacy</h3>

            <p className="cpp-text">
              HirelinkInfo is intended only for individuals aged 18 years or
              above. We do not knowingly collect data from minors.
            </p>

            <h3 className="cpp-heading">14. Your Rights</h3>

            <p className="cpp-text">
              As a registered pharma job seeker, you may:
            </p>
            <p className="cpp-text">
              ● Access your profile<br></br>● Update incorrect information
              <br></br>● Request account deactivation<br></br>● Contact support
              for privacy-related concerns{" "}
            </p>
            <p className="cpp-text">
              Requests can be sent via the contact details available on our
              website.
            </p>

            <h3 className="cpp-heading">15. International Users</h3>

            <p className="cpp-text">
              HirelinkInfo operates from Nashik, Maharashtra, India. If you
              access the platform from outside India, you are responsible for
              compliance with your local data laws.
            </p>

            <h3 className="cpp-heading">16. Limitation of Liability</h3>

            <p className="cpp-text">
              While we implement security measures, Hirelink Infotech Pvt Ltd is
              not liable for:
            </p>
            <p className="cpp-text">
              ● Data breaches beyond reasonable control<br></br>● Employer
              misuse of shared information<br></br>● Third-party cyber
              incidents{" "}
            </p>

            <h3 className="cpp-heading">17. Policy Updates</h3>

            <p className="cpp-text">
              We reserve the right to modify this Privacy Policy at any time.
              Updated versions will be posted on https://hirelinkinfo.com.
            </p>
            <p className="cpp-text">
              Continued use of the pharma job portal indicates acceptance of
              revised policies.
            </p>

            <p className="cpp-footer-text"style={{fontWeight:"bold"}}>
              © {new Date().getFullYear()} All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicies;
